var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    [
      _c(
        "v-expansion-panel-header",
        [
          _c(
            "v-layout",
            { attrs: { "justify-space-between": "", "align-center": "" } },
            [
              _c("div", { staticStyle: { "font-size": "11px" } }, [
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("ID: ")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mr-3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.assetReservationObject.asset_reservation.ar_id
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("ExternalID")) + ": ")
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getAssetReservationExternalID()) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              !_vm.disabled && _vm.hasPermission("update")
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-0",
                      attrs: {
                        disabled: !_vm.saveIsEnabled,
                        "x-small": "",
                        icon: "",
                        text: "",
                        color: "accent"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.saveChanges.apply(null, arguments)
                        }
                      }
                    },
                    [_c("v-icon", { attrs: { size: "15" } }, [_vm._v("save")])],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticStyle: { "background-color": "#f0f0ef" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    _vm._l(_vm.fields, function(field) {
                      return _c(
                        "input-field",
                        {
                          key: field.label + field.order,
                          ref: "formInputField",
                          refInFor: true,
                          attrs: {
                            value: _vm.getValueInObject(field.var_name),
                            label: field.label,
                            "variable-name": field.var_name,
                            inputType: field.input_type,
                            size: field.size,
                            required: field.required,
                            selectOptions: field.select_list_name,
                            radioOptions: field.radio_options,
                            fieldDisabled: field.disable,
                            formDisabled: _vm.disabled,
                            hide: field.hide
                          },
                          on: {
                            input: function($event) {
                              return _vm.setValueInObject(
                                field.var_name,
                                $event
                              )
                            }
                          }
                        },
                        [
                          field.input_type === "checkbox"
                            ? _c(
                                "div",
                                { staticClass: "checkbox-group" },
                                _vm._l(field.checkbox_options, function(
                                  checkbox
                                ) {
                                  return _c("v-checkbox", {
                                    key: checkbox.label,
                                    attrs: {
                                      label: checkbox.label,
                                      color: "#4fa2b7",
                                      ripple: false,
                                      disabled: _vm.disabled || field.disable,
                                      value: _vm.getValueInObject(
                                        checkbox.var_name
                                      )
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.setValueInObject(
                                          checkbox.var_name,
                                          $event
                                        )
                                      }
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b67e5aa8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b67e5aa8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AssetReservationTab/AssetReservationObjectPanel.vue
// module id = null
// module chunks = 